import { setSid, clearSid } from '../helpers/session'

// const usersState = {};

const keys = [
  "auth_login",
  "auth_autologin",
  "auth_sid",
  "auth_signup",
  "auth_logback"
]

const lastUserPage = {}

export default function authReducer(state, action) {  
  if (typeof state === 'undefined') {
    return {}
  }
  let {type, key} = action;
  if (keys.indexOf(key) != -1 && type == "api_success") {
    if (action.data.sid) {
      setSid(action.data.sid)  
    }      
    return {
      user: action.data.user,
      lastPage: lastUserPage[action.data.user.aid]
    }      
  }
  if (key == "auth_logout" && type == "api") {
    if (!action.keepSid) {
      clearSid();  
    }
    if (action.keepSid && action.aid && action.pathname) {
      lastUserPage[action.aid] = action.pathname
    }
    return {
      keepSid: !!action.keepSid
    };
  }
  return state;
}